export default __webpack_public_path__ + "assets/icon-stats.09736fa0.webp";